import { render, staticRenderFns } from "./statusLabel.vue?vue&type=template&id=1a5095db&scoped=true"
import script from "./statusLabel.vue?vue&type=script&lang=js"
export * from "./statusLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5095db",
  null
  
)

export default component.exports